module.exports = __webpack_public_path__ + "static/media/prev.79e27e39.svg";